import { useMutation } from '@apollo/client';
import { CREATE_TAG_MUTATION } from '../mutations/CREATE_TAG_MUTATION';

export function useCreateTagMutation() {
    return useMutation( CREATE_TAG_MUTATION );
}
